import { ArrowRight } from 'lucide-react';
import { iconFor, slugify, priceText } from './serviceMeta';

function FeeNote({ service }) {
  if (service.diagnostic_fee_applies) {
    return <span className="text-[#ff00ff]">+ $75 diagnostic, credited toward total</span>;
  }
  if (service.name === 'Remote Device Troubleshooting') {
    return <span className="text-[#39ff88]">Flat rate · no diagnostic fee</span>;
  }
  if (!service.requires_payment) return <span className="text-[#39ff88]">No upfront charge</span>;
  return <span className="text-slate-400">No diagnostic fee</span>;
}

export function ServiceCard({ service, onStart, ctaLabel = 'Get started' }) {
  const Icon = iconFor(service.name);
  const slug = slugify(service.name);
  return (
    <div className="nw-card p-6 flex flex-col" data-testid={`service-card-${slug}`}>
      <div className="flex items-start justify-between mb-5">
        <div className="w-11 h-11 border border-[#00f0ff]/50 flex items-center justify-center text-[#00f0ff]">
          <Icon size={22} strokeWidth={1.5} />
        </div>
        <div className="text-right">
          <p className="font-display text-2xl font-extrabold text-white" data-testid={`service-price-${slug}`}>
            {priceText(service)}
          </p>
          {service.price_suffix && !service.pricing_label && (
            <p className="font-tech text-xs text-slate-400 uppercase tracking-wider">{service.price_suffix.replace('/', 'per ')}</p>
          )}
        </div>
      </div>
      <h3 className="font-heading text-lg font-bold text-white mb-2 leading-snug">{service.name}</h3>
      <p className="text-sm text-slate-300 leading-relaxed mb-4 flex-1">{service.description}</p>
      <p className="font-tech text-xs uppercase tracking-wider mb-5"><FeeNote service={service} /></p>
      <button
        onClick={() => onStart(service)}
        className="nw-btn w-full flex items-center justify-between px-4 py-3 border border-[#00f0ff] text-[#00f0ff] hover:bg-[#00f0ff] hover:text-[#0a0a1f] font-tech uppercase tracking-wider text-sm"
        data-testid={`service-start-${slug}`}
      >
        {ctaLabel} <ArrowRight size={16} />
      </button>
    </div>
  );
}
